
export default class PredictionReport {
  constructor(report) {
    Object.keys(report).forEach(key => this[key] = report[key])
    this.tagArray = []
    this.horsesArray = []
    Object.keys(this.tags).forEach(key => this.tagArray.push({tag: key, data: this.tags[key]}))
    Object.keys(this.horses).forEach(key => this.horsesArray.push({name: key, data: this.horses[key]}))
    this.raceProperties = []

    this.tagArray.forEach(tag => {
      if (tag.data.raceProperties) {
        Object.keys(tag.data.raceProperties).forEach(raceProperty => {
          if (this.raceProperties.indexOf(raceProperty) === - 1) this.raceProperties.push(raceProperty)
        })
      }
    })

    this.tagArray.forEach(tag => {
      tag.data.netScore =  tag.data.score / tag.data.scoresUsed
      if (report.averageTagScore) {
        tag.data.netScore > report.averageTagScore? tag.data.aboveAverage = true : tag.data.aboveAverage = false
      }
      //Add the horses
      tag.horses = []
      this.horsesArray.forEach(horse => {
        if (horse.data.tags.indexOf(tag.tag) > -1) tag.horses.push(horse.name)
      })
    })

    //Sort by score
    this.tagArray.sort((a,b) => b.data.netScore - a.data.netScore)
  }
}
